import React from "react"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import ExpandMenuEllipsisButton from "shared/buttons/ExpandMenuEllipsisButton"
import { useSurveyConfigurationContext } from "contexts/SurveyConfigurationContext"
import { surveyConfigurationPath } from "utils/routeHelpers"

const goToSurveyConfigurationPath = (surveyConfigurationId) => () => {
  window.location.pathname = surveyConfigurationPath(surveyConfigurationId)
}

const SurveyConfigurationTileMenu = () => {
  const { surveyConfiguration } = useSurveyConfigurationContext()
  const { id: surveyConfigurationId } = surveyConfiguration

  return (
    <ExpandMenu expandMenuComponent={<ExpandMenuEllipsisButton />}>
      <ExpandMenuItem onClick={goToSurveyConfigurationPath(surveyConfigurationId)}>
        <span>Open</span>
      </ExpandMenuItem>
    </ExpandMenu>
  )
}

export default SurveyConfigurationTileMenu
